import {Component, HostBinding, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TemplatesComponent{
    @HostBinding('class') hostClass ='todo-application';
}
